'use strict';

var processInclude = require('base/util');
var customUtil = require('./customUtil');

/**
 * Set Alt text for the images
 */
// function setAltText() {
//     $.each($('.primary-images .carousel-item img'), function(index, val) {
//         $($('img.zoomer-image')[index]).attr('alt', $(val).attr('alt'));
//     });
// }

/**
 * Init the zoom functionality
 */
function initZoom() {
    var imageToOpen = 0;
    var imageList = [];
    var altList = [];

    $('#modalZoomLoading').removeClass('d-none');
    $('#zoomModal .modal-body').addClass('hide');

    $('body').on('click', '.primary-images .carousel-item:not(.pdp-video-container) img', function() {
        imageToOpen = $(event.target).data('image') ? $(event.target).data('image') : 0;
        var carouselImages = $(this)
            .parents('.primary-images')
            .find('img');

        $('.zoomer_basic').zoomer('destroy');

        $('.zoomer_basic')
            .empty()
            .removeClass('zoomer-element');

        imageList = [];
        altList = [];
        $.each(carouselImages, function(index, val) {
            imageList.push($(val).attr('data-zoom'));
            altList.push($(val).attr('alt'));
        });

        var zoomerOpt = {
                index: imageToOpen,
                // increment: 0.01,
                // interval: 0.1,
                // marginMax: 100,    //Left commented for any future changes
                imageList: imageList,
                altList: altList,
                callback: function () {
                    var iosVer = customUtil.iosVersion();
                    if (/iphone/i.test(navigator.userAgent)) {
                        // zoomerOpt.controls = {position: 'top'};
                        var retryFunc = setInterval(function () {
                            if ($('.zoomer-holder').length > 0) {
                                setTimeout(function () {
                                    var zhptop = $('.zoomer-holder').offset().top;
                                    $('.zoomer .zoomer-controls-bottom').css('bottom', (zhptop - 132) + 'px');
                                    clearInterval(retryFunc);
                                }, 300);
                            }
                        }, 500);
                    }
                }
            };

        $('.zoomer_basic').zoomer(zoomerOpt);

        $('#zoomModal').modal();
    });

    // $('body').on('click', '.pdp-video-container', function() {
    //     $('.zoomer_basic').zoomer('destroy');
    //     $('.zoomer_basic')
    //         .empty()
    //         .removeClass('zoomer-element');

    //     var iframeSrc = $(this)
    //         .find('iframe')
    //         .attr('src');
    //     if (iframeSrc != null) {
    //         var iframediv = '<iframe class="pdp-zoom-frame" src="' + iframeSrc + '" frameborder="0" allowfullscreen="" data-widths="[0]">';
    //         $('.zoomer_basic').append(iframediv);
    //         $('.zoomer_basic').addClass('iframe-loaded');
    //         $('#zoomModal').modal();
    //         $('body').load('iframe.pdp-zoom-frame', function() {
    //             $('#modalZoomLoading').hide();
    //         });
    //     }
    // });

    $('#zoomModal .closeIcon').on('click', function() {
        if ($('.zoomer_basic').hasClass('iframe-loaded')) {
            $('.zoomer_basic')
                .empty()
                .removeClass('zoomer-element iframe-loaded');
        }

        $('.zoomer_basic').zoomer('destroy');
    });

    $('#zoomModal').on('shown.bs.modal', function() {
        $('#zoomModal .modal-body').removeClass('hide');

        setTimeout(function() {
            $('.zoomer_wrapper').zoomer('resize');
            // $('#modalZoomLoading').addClass('d-none');
            // setAltText();
        }, 250);

        $(window).on('resize', function() {
            $('.zoomer_wrapper').zoomer('resize');
        });
    });
}

$(document).ready(function() {
    processInclude(require('./zoomer'));

    if ($('#zoomImages').length > 0) {
        initZoom();
    }
});
